export default "/survey_assets/images/Zev.6d9bb87d7380cc83d1d0e5fd151f4580.jpeg";